export enum RouteKeys {
  Home = '/',
  NotFound = '/page-not-found',
  SearchResult = '/search-result',
  Checkout = '/checkout',
  MyOrder = '/my-order/:status?',
  MyAccount = '/my-account',
  UserManagement = '/my-account/user-management',
  FAQ = '/faq',
  BannerOffer = '/banner-offer/:id?',
  PrivacyPolicy = '/privacy-policy',
  TermsOfService = '/terms-of-use',
}
